module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tab-panel padded"
  }, [_c('agent', {
    on: {
      "updateFields": _vm.updateFields
    }
  }), _vm._v(" "), _c('basic'), _vm._v(" "), _c('price-counters', {
    attrs: {
      "editable": false
    },
    on: {
      "updatePrices": _vm.updatePrices
    }
  }), _vm._v(" "), _c('customer', {
    on: {
      "updateFields": _vm.updateFields
    }
  }), _vm._v(" "), _c('transport', {
    on: {
      "updateFields": _vm.updateFields
    }
  }), _vm._v(" "), _c('extras', {
    attrs: {
      "editable": false
    },
    on: {
      "updateExtras": _vm.updateExtras
    }
  }), _vm._v(" "), _c('notes', {
    on: {
      "updateNotes": _vm.updateNotes
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37592992"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reservations/view/ViewMore.vue
// module id = 1867
// module chunks = 0